import { useMemo, useState } from "react";
import { Plus, Search } from "lucide-react";

const money = (v) => `₺${Number(v || 0).toFixed(2)}`;

// Reusable searchable + category-tabbed product list with qty steppers.
// products: [{id,name,price,categoryId,...}], categories: [{id,name}]
// cart: { [productId]: { p, qty } }, onAdd(p), onSub(p)
export function MenuPicker({ products, categories = [], cart = {}, onAdd, onSub, maxListHeight = "max-h-72" }) {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return products.filter(
      (p) =>
        (cat === "all" || p.categoryId === cat) &&
        (!needle || p.name.toLowerCase().includes(needle) || (p.description || "").toLowerCase().includes(needle))
    );
  }, [products, q, cat]);

  return (
    <div className="space-y-2.5">
      <div className="relative">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Ürün ara..."
          className="lux-input pl-9 py-2 text-sm"
          data-testid="picker-search"
        />
      </div>
      <div className="flex gap-1.5 overflow-x-auto no-scrollbar pb-1">
        <button onClick={() => setCat("all")} className={`px-3 py-1.5 rounded-full text-xs whitespace-nowrap ${cat === "all" ? "btn-gold" : "btn-outline"}`} data-testid="picker-cat-all">Tümü</button>
        {categories.map((c) => (
          <button key={c.id} onClick={() => setCat(c.id)} className={`px-3 py-1.5 rounded-full text-xs whitespace-nowrap ${cat === c.id ? "btn-gold" : "btn-outline"}`} data-testid={`picker-cat-${c.id}`}>{c.name}</button>
        ))}
      </div>
      <div className={`${maxListHeight} overflow-y-auto no-scrollbar space-y-1.5`}>
        {filtered.map((p) => (
          <div key={p.id} className="flex items-center justify-between bg-[#18181C] rounded-lg px-3 py-2" data-testid={`picker-prod-${p.id}`}>
            <div className="min-w-0">
              <div className="text-sm text-white truncate">{p.name}</div>
              <div className="font-mono text-[11px] text-[#FFE599]">{money(p.price)}</div>
            </div>
            <div className="flex items-center gap-2">
              {cart[p.id] && <><button onClick={() => onSub(p)} className="btn-outline h-7 w-7 rounded-lg text-sm">-</button><span className="font-mono w-5 text-center text-white">{cart[p.id].qty}</span></>}
              <button onClick={() => onAdd(p)} className="btn-gold h-7 w-7 rounded-lg flex items-center justify-center" data-testid={`pick-${p.id}`}><Plus size={14} /></button>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p className="text-center text-zinc-600 text-sm py-6">Ürün bulunamadı</p>}
      </div>
    </div>
  );
}
